import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-check.tsx
/**
* icon.24.check
*
* Keywords: checkmark, tick, confirm, validation, approval, complete, success, affirmative
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE1LjU4NCA3LjcyMmEuNS41IDAgMCAxIC44MzIuNTU1bC01IDcuNWEuNTAyLjUwMiAwIDAgMS0uNzcuMDc2bC0zLTNhLjUuNSAwIDAgMSAuNzA4LS43MDdsMi41NjggMi41Njl6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1220
*/
const Icon24Check = memo(function Icon24Check(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M15.584 7.722a.5.5 0 0 1 .832.555l-5 7.5a.502.502 0 0 1-.77.076l-3-3a.5.5 0 0 1 .708-.707l2.568 2.569z"
		})
	});
});
//#endregion
export { Icon24Check };

//# sourceMappingURL=icon-24-check.js.map